import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EsnAppeloffreService extends CrudService<ApiResponse<any>, number>{

  constructor(_http: HttpClient) { 
    super(_http, `${environment.baseUrl}`) 
  }

  /* get list appel offre */

getListappeloffre(
  data: { 
   
    per_page?: number, 
    page?: number,
    sort?:number,
    sortAttribute?:string
   })
    {
      let sort =''
      if(data?.sort) sort=`&sort=${data.sort}&sortAttribute=${data.sortAttribute}`
  return this._http.get<ApiResponse<any>>(`${this._base}/api/JobRequest/getListJobRequetsDedicatedToEsn?
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
}


  /* get list suggestion job offer */

  getListSuggestionJobRequest(
    data: { 
      consultant_id:number
      per_page?: number, 
      page?: number,
      sort?:number,
      sortAttribute?:string
     })
      {
        let sort =''
        if(data?.sort) sort=`&sort=${data.sort}&sortAttribute=${data.sortAttribute}`
    return this._http.get<ApiResponse<any>>(`${this._base}/api/JobRequest/getJobRequestSuggestionForConsultant?consultant_id=${data?.consultant_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  listFamilleaddquestion()
  {
  return this._http.get<ApiResponse<any>>(this._base + `/api/FamilleDefaultEvaluation/getAllSansPaginate`);
  }
  /* get list suggestion job request */

  getListSuggestionJobOffer(
    data: { 
    consultant_id:number
    per_page?: number, 
    page?: number,
    sort?:number,
    sortAttribute?:string
   }){
       let sort =''
       if(data?.sort) sort=`&sort=${data.sort}&sortAttribute=${data.sortAttribute}`
   return this._http.get<ApiResponse<any>>(`${this._base}/api/JobRequest/getJobOffersSuggestionForConsultant?consultant_id=${data?.consultant_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  /* get list candidatureappel d'offre */

  getlistcandidature(data: { 
    company_id?: any,
    per_page?: number, 
    page?: number,
    sort?: number,
    sortAttribute?: string
  }) {
    let sort = '';
    let sortAttr = '';
  
    if (data?.sort) {
      sort = `&sort=${data.sort}`;
      sortAttr = `&sortAttribute=${data.sortAttribute}`;
    }
  
    const url = this._base + `/api/CompanyApply/getListCandidaturesByESNForJobRequest?company_id=${data.company_id}&per_page=${data.per_page}&page=${data.page}${sort}${sortAttr}`;

    
    return this._http.get<ApiResponse<any>>(url);
  }
  

  /* search candidature */

  searchcandidature(data:any): Observable<ApiResponse<any>>{
  
    return this._http.post<ApiResponse<any>>(this._base+`/api/CompanyApply/searchInCandidaturesJobRequest`,data).pipe(
      map((res: any) => {
        if (res) {
          return res;
        }
      }));
  }
/*retirer candidature*/
retirercandidature(data:any){
  return this._http.delete<ApiResponse<any>>(this._base+`/api/CompanyApply/deleteCandidatureFromJobRequest?company_id=${data.company_id}&job_request_id=${data.job_request_id}&user_id=${data.user_id}`,data);
}

 /*get job offre candidature  by id */
 getappeloffrecandidatureById(company_apply_id:number): Observable<ApiResponse<any>>{
  return this._http.get<ApiResponse<any>>(this._base+`/api/CompanyApply/getDetailsCandidatureJobRequest?company_apply_id=${company_apply_id}`);
}
 /*get skills appel d'offre*/
 getskillsappeloffre(job_request_id:number): Observable<ApiResponse<any>>{
  return this._http.get<ApiResponse<any>>(this._base+`/api/SkillsJob/getByJobRequest?job_request_id=${job_request_id}`);
}

/*contact responsable */
contactjobrequest(body: any): Observable<ApiResponse<any>> {
  console.log("url",this._base + "/api/JobRequest/contactManagerJobRequest", body)
return this._http.post<ApiResponse<any>>(this._base + "/api/JobRequest/contactManagerJobRequest", body);
 }

// search appel offre /
searchappeloffre(data:any): Observable<ApiResponse<any>>{
  console.log('data',data);
  let tabs=this.findDoubleQuotes(data.search);
   
  if(tabs.length<=2)
  data.search='"' + data.search + '"';
  console.log("data of searchCandidat","count = "+tabs.length,data.search)
  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/searchJobRequetsDedicatedToEsn`,data).pipe(
    map((res: any) => {
      if (res) {
        console.log(res);
        return res;
      }
    }));
}

// search suggestion job offer /
searchSuggestionJobRequest(data:any): Observable<ApiResponse<any>>{
  console.log('data',data);
  let tabs=this.findDoubleQuotes(data.search);
   
  if(tabs.length<=2)
  data.search='"' + data.search + '"';
  console.log("data of searchCandidat","count = "+tabs.length,data.search)
  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/searchJobRequestSuggestionForConsultant`,data).pipe(
    map((res: any) => {
      if (res) {
        console.log(res);
        return res;
      }
    }));
}
// search suggestion job request /
searchSuggestionJobOffer(data:any): Observable<ApiResponse<any>>{
  console.log('data',data);
  let tabs=this.findDoubleQuotes(data.search);
   
  if(tabs.length<=2)
  data.search='"' + data.search + '"';
  console.log("data of searchCandidat","count = "+tabs.length,data.search)
  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/searchJobOffersSuggestionForConsultant`,data).pipe(
    map((res: any) => {
      if (res) {
        console.log(res);
        return res;
      }
    }));
}

 /*get job offre  by id */
 getappeloffreById(id:number): Observable<ApiResponse<any>>{
  return this._http.get<ApiResponse<any>>(this._base+`/api/JobRequest/getById/${id}`);
}



 /*get list consultant   by offre */
 getlistconsultantbyoffre(esn_name:any): Observable<ApiResponse<any>>{
  console.log(this._base+`/api/ConsultantEsn/getConsultantsforConsultantExterne?esn_name=${esn_name}`)
  return this._http.get<ApiResponse<any>>(this._base+`/api/ConsultantEsn/getConsultantsforConsultantExterne?esn_name=${esn_name}`);
}
getcallById(id: string) {
  return this._http.get<ApiResponse<any>>(
    this._base + `/api/JobRequest/getById/${id}`
  );
}

getcallByIdcandidature(id: string,user_id:any) {
  return this._http.get<ApiResponse<any>>(
    this._base + `/api/CompanyApply/getDetailsCandidatureJobRequest?job_request_id=${id}&user_id=${user_id}`
  );
}

applyJob(data:any){
  console.log(this._base+`/api/CompanyApply/applyConsultantForJobRequest`,data)
  return this._http.post<ApiResponse<any>>(this._base+`/api/CompanyApply/applyConsultantForJobRequest`,data);
}




 /*archiver appel offer */
archiverappeloffre(job_request_id  :number,company_id:number){
  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/CompanyArchivedJobRequest?job_request_id=${job_request_id}&company_id=${company_id}`,{});
}


// ------------------api appel offre archived-----------------------//

 /*get list appel offre archived */
 getListappeloffrearchived(
  data: { 
   id:number,
    per_page?: number, 
    page?: number,
    sort?:number,
    sortAttribute?:string
   })
    {
      let sort =''
      if(data?.sort) sort=`&sort=${data.sort}&sortAttribute=${data.sortAttribute}`
      console.log("url",`${this._base}/api/JobRequest/getListJobRequestArchivedDedicatedToEsn?id=${data.id}&
      per_page=${data?.per_page}&page=${data?.page}${sort}`)
  return this._http.get<ApiResponse<any>>(`${this._base}/api/JobRequest/getListJobRequestArchivedDedicatedToEsn?id=${data.id}&
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
}

 /*restaurer appel offer */
 restaurerappeloffre(job_request_id  :number,company_id:number){
  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/CompanyRestoredJobRequest?job_request_id=${job_request_id}&company_id=${company_id}`,{});
}


// search appel offre archived //////
searchappeloffrearchived(data:any): Observable<ApiResponse<any>>{
  console.log('data',data);
  let tabs=this.findDoubleQuotes(data.search);
   
  if(tabs.length<=2)
  data.search='"' + data.search + '"';
  console.log("data of searchCandidat","count = "+tabs.length,data.search)

  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/searchInListJobRequestArchivedDedicatedToEsn`,data).pipe(
    map((res: any) => {
      if (res) {
        console.log(res);
        return res;
      }
    }));
}
findDoubleQuotes(str: string): number[] {
  const indices: number[] = [];
  for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
          indices.push(i);
      }
  }
  return indices;
}


  /*get candidate  by id */
  getUserById(id:number){
    return this._http.get<ApiResponse<any>>(this._base+`/api/User/userProfile?user_id=${id}`);
  }
  //////////////////////////////ajout template esn////////////////////////////
  ajoutertemplate(data: any){
    return this._http.post<ApiResponse<any>>(this._base+`/api/Evaluation/create`, data);
  }
  /////////////////////////////////////////////////////////////////////////////////////
  gettemplateevaluationList(esn_id: string | null, data?: { per_page?: number, page?: number }) {
    return this._http.get<ApiResponse<any>>(this._base + `/api/Evaluation/getByEsn?esn_id=${esn_id}&per_page=${data?.per_page}&page=${data?.page}`);
  }

 ajouterquestion(data: any){
  return this._http.post<ApiResponse<any>>(this._base+`/api/QuestionEvaluation/add`, data);
} 


getchapitreList(id: string | null,data?: { per_page?: number, page?: number, sort?: number, sortAttribute?: string })
{
let sort = ''
if (data?.sort) sort = `&sort=${data.sort}&sortAttribute=${data?.sortAttribute}`
return this._http.get<ApiResponse<any>>(this._base + `/api/DefaultReview/getAllChaptersEvaluations?id=${id}&per_page=${data?.per_page}&page=${data?.page}${sort}`);
}
getchapitreListaddquest(id: string | null)
{

return this._http.get<ApiResponse<any>>(this._base + `/api/DefaultReview/getAllChaptersEvaluations?id=${id}&state=1`);
}

/* detail intervenant */
detailchapitre(id : any) {
  return this._http.get<ApiResponse<any>>(this._base + `/api/Evaluation/getEvaluationDetails/${id }`);
}


getlistetemplate(esn_id: string | null,data?:{per_page?:number,page?:number,sortAttribute?:string,sort?:number}) {
 
  return this._http.get<ApiResponse<any>>(this._base + `/api/DefaultReview/getEvaluations?id=${esn_id}&per_page=${data?.per_page}&page=${data?.page}&sort=${data?.sort}&sortAttribute=${data?.sortAttribute}`);
}
/*list Evaluation Admin*/
getListEvaluationDefault(
  params: {
    per_page?: number;
    page?: number;
    name?: any;
    type?:any;
    date?: any;
    sort?: number;
    sortAttribute?: string;
    
  } = {}
) {
  const perPage = Number(params?.per_page || '');
  const page = Number(params?.page || '');
  const name = params?.name || '';
  const type = params?.type || '';
  const date = params?.date || '';
  const sort = params?.sort ? `&sort=${params.sort}&sortAttribute=${params.sortAttribute || ''}` : '';
  console.log('API Parameters:', { perPage, page, sort, name, type,date });
  return this._http.get<ApiResponse<any>>(
    `${this._base}/api/evalAdmin/template/all?per_page=${perPage}&page=${page}${sort}&name=${name}&type=${type}&date=${date}`
  );
}
/*Clonage template Admin*/
clonagetemplateAdmin(template_id: any,data: any){
  return this._http.post<ApiResponse<any>>(this._base+`/api/evalAdmin/templates/${template_id}/clone`,data);
}
/*ajout nouveau evaluation*/
createnouveauevaluation(data: any){
  return this._http.post<ApiResponse<any>>(this._base+`/api/DefaultReview/cloneEvaluation`, data);
}

getListsuggestion(
  data: { 
    esn_id:number,
    job_request_id:number,
    per_page?: number, 
    page?: number,
    sort?:number,
    sortAttribute?:string
   })
    {
      let sort =''
      if(data?.sort) sort=`&sort=${data.sort}&sortAttribute=${data.sortAttribute}`
  return this._http.get<ApiResponse<any>>(`${this._base}/api/JobRequest/getSuggestionByESNforJobRequest?esn_id=${data.esn_id}&job_request_id=${data.job_request_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`);
}

/*suggestion*//////
searchconsultantsuggestion(data:any): Observable<ApiResponse<any>>{
  console.log('data',data);
  let tabs=this.findDoubleQuotes(data.search);
   
  if(tabs.length<=2)
  data.search='"' + data.search + '"';
  console.log("data of searchCandidat","count = "+tabs.length,data.search)
  return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/searchInSuggestionByESNforJobRequest?esn_id=${data.esn_id}&job_request_id=${data.job_request_id}`,data).pipe(
    map((res: any) => {
      if (res) {
        console.log(res);
        return res;
      }
    }));
}


getlistequestion( 
  data: { 
    id:string | null,
    esn_id:string | null,
   }
) {
 
  return this._http.get<ApiResponse<any>>(this._base + `/api/DefaultReview/getAllQuestions?id=${data.id}&default=1&esn_id=${data.esn_id}`);
}
getlistequestion1(id: string | null) {
 
  return this._http.get<ApiResponse<any>>(this._base + `/api/DefaultReview/getAllQuestions?id=${id}&default=0`);
}
// create 
envoyerEvaluationSend(body: any) : Observable<ApiResponse<any>>{
  return this._http.post<ApiResponse<any>>(this._base + `/api/EvaluationSend/sendEvalToCandidate`, body);
}

/* get elment of header table call odder list */
getHeaderElements(id:number){
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=7&interface=7&id=${id}`);
}
getHeaderElementsentrepriseclienfinal(id:number){
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`);

}

/* get elment of header table call odder list */
changeDelectedElementHeader(data:any){
  return this._http.post<ApiResponse<any>>(this._base+`/api/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,data);
}
listPageActorIntervenant(){
   
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=11`);
}
/* change Sub Page State */
changeSubPageStateIntervenant(data:any){
  return this._http.post<ApiResponse<any>>(this._base+`/api/UserPageActeur/addRemoveSubPageByEmployee`,data);
}
listPageActorcandidatureoffreemploiIntervenant(){
   
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=17`);
}
/* change Sub Page State */
changeSubPageStatecandidatureoffreemploiIntervenant(data:any){
  return this._http.post<ApiResponse<any>>(this._base+`/api/UserPageActeur/addRemoveSubPageByEmployee`,data);
}

}
